import React, { useEffect, useState } from "react";
import copy from "simple-copy-to-clipboard";

export const Analytics = () => {
    const [deleteButtonVisible, setDeleteButtonVisible] = useState(false);

    const handleCopyClick = () => {
        const value = localStorage.getItem("stats/routine");

        if (copy(value)) {
            alert("success");
        } else {
            alert("error");
        }
    };

    return (
        <div>
            <button onClick={handleCopyClick} style={{ fontSize: "20px" }}>
                Copy state from this device
            </button>
            <br />
            <br />
            {!deleteButtonVisible && (
                <button
                    onClick={() => {
                        setDeleteButtonVisible(!deleteButtonVisible);
                    }}
                >
                    Clear ONLY current field in localStorage
                </button>
            )}
            {deleteButtonVisible && (
                <>
                    <p style={{ marginBottom: "10px" }}>Are you sure?</p>
                    <button
                        onClick={() => {
                            setDeleteButtonVisible(false);
                        }}
                        style={{ fontSize: "20px", background: "lightgreen" }}
                    >
                        NO
                    </button>
                    <button
                        onClick={() => {
                            localStorage.removeItem("stats/routine");
                            location.reload();
                        }}
                        style={{ marginLeft: "10px", background: "#ff7575" }}
                    >
                        yes
                    </button>
                </>
            )}
        </div>
    );
};
